import React, { ChangeEvent, ReactNode } from 'react';

import './styles.scss';

interface Props {
    id: string;
    checked: boolean;
    children: ReactNode;
    hasError?: boolean;
    className?: string;
    onChange: (id: string, checked: boolean) => void;
}

export const TermsCheckbox = ({ id, checked, hasError, children, className = '', onChange }: Props) => {
    const changeHandler = (e: ChangeEvent<HTMLInputElement>) => onChange(id, e.target.checked);
    return (
        <div className={`terms-checkbox ${className}`}>
            <input type='checkbox' id={id} checked={checked} onChange={changeHandler} />
            <label
                className={`terms-checkbox__label ${hasError ? 'terms-checkbox__label--has-error' : ''}`}
                htmlFor={id}
            >
                <div className='terms-checkbox__icon'></div>
                <div className='terms-checkbox__content'>{children}</div>
            </label>
        </div>
    );
};
